import { call, put, takeEvery } from "redux-saga/effects"

import {
  CREATE_ADMIN_NOTIFICATION_TEMPLATE,
  DELETE_ADMIN_NOTIFICATION_TEMPLATE,
  GET_ADMIN_NOTIFICATION_TEMPLATES,
  GET_ADMIN_USER_NOTIFICATION_PREFERENCES,
  UPDATE_ADMIN_NOTIFICATION_TEMPLATE,
  UPDATE_ADMIN_USER_NOTIFICATIONS
} from "./actionTypes"

import {
  getAdminNotificationTemplatesSuccess,
  getAdminNotificationTemplatesError,
  createAdminNotificationTemplateSuccess,
  createAdminNotificationTemplateError,
  deleteAdminNotificationTemplateSuccess,
  deleteAdminNotificationTemplateError,
  updateAdminUserNotificationsSuccess,
  updateAdminUserNotificationsError,
  getAdminUserNotificationPreferencesSuccess,
  getAdminUserNotificationPreferencesError,
  updateAdminNotificationTemplateSuccess,
  updateAdminNotificationTemplateError,
} from "./actions"

import { genericDeleteRequest, genericGetRequest, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminNotificationTemplates() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_notification_templates`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminNotificationTemplatesSuccess(response))
  } catch (error) {
    yield put(getAdminNotificationTemplatesError(error))
  }
}

function* onCreateAdminNotificationTemplates({ payload: { template, history } }) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_notification_templates`,
      {
        body: JSON.stringify(template),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    history.push("/admin_notification_templates");
    yield put(createAdminNotificationTemplateSuccess(response))
  } catch (error) {
    yield put(createAdminNotificationTemplateError(error))
  }
}

function* onUpdateAdminNotificationTemplates({ payload: { template, history } }) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_notification_templates/${template.id}`,
      {
        body: JSON.stringify({data: template}),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    history.push("/admin_notification_templates");
    yield put(updateAdminNotificationTemplateSuccess(response))
  } catch (error) {
    yield put(updateAdminNotificationTemplateError(error))
  }
}

function* onDeleteAdminNotificationTemplates(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_notification_templates/${action.payload.id}`,
      { body: JSON.stringify({...action.payload}),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteAdminNotificationTemplateSuccess(response))
  } catch (error) {
    yield put(deleteAdminNotificationTemplateError(error))
  }
}

function* onGetAdminUserNotifications() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_notification_preferences`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminUserNotificationPreferencesSuccess(response))
  } catch (error) {
    yield put(getAdminUserNotificationPreferencesError(error))
  }
}

function* onUpdateAdminUserNotifications(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_notification_preferences`,
      {
        body: JSON.stringify(action.payload),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(updateAdminUserNotificationsSuccess(response))
  } catch (error) {
    yield put(updateAdminUserNotificationsError(error))
  }
}

function* adminNotificationsSaga() {
  yield takeEvery(GET_ADMIN_NOTIFICATION_TEMPLATES, onGetAdminNotificationTemplates)
  yield takeEvery(CREATE_ADMIN_NOTIFICATION_TEMPLATE, onCreateAdminNotificationTemplates)
  yield takeEvery(UPDATE_ADMIN_NOTIFICATION_TEMPLATE, onUpdateAdminNotificationTemplates)
  yield takeEvery(DELETE_ADMIN_NOTIFICATION_TEMPLATE, onDeleteAdminNotificationTemplates)
  yield takeEvery(GET_ADMIN_USER_NOTIFICATION_PREFERENCES, onGetAdminUserNotifications)
  yield takeEvery(UPDATE_ADMIN_USER_NOTIFICATIONS, onUpdateAdminUserNotifications)
}

export default adminNotificationsSaga;
